export const APP_BLACK = "#2c2d32";
export const APP_PRIMARY = "#a29e85";
export const FORM_UNDERLINE = "#c8c8c9";
export const APP_WHITE = "#ffffff";
